// extracted by mini-css-extract-plugin
export var card = "_75-0";
export var failedIcon = "_75-4";
export var failedIconBadge = "_75-3";
export var icon = "_75-1";
export var successIcon = "_75-2";